import React from 'react'
import { injectIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import MediaQuery from 'react-responsive'

import Spinner from '@uniiverse/library/components/spinner'
import ChevronIcon from '@uniiverse/library/assets/icons/chevron.svg'

import { BREAK_MD } from 'src/lib/media-queries'
import { formattedDateTimeRange, formattedPriceRange } from 'src/lib/formatter'

import { Carousel } from 'src/elements/Carousel.tsx'
import { EventCard } from '../event-card/index'
import { FindMoreEvents } from '../find-more-events/index'

import locale from '../find-more-events/locale'
import style from './index.css'

export const MAX_EVENT_CARDS = 4

const EventsCarouselComponent = ({
  loading,
  title,
  events,
  sectionId,
  page,
  intl,
  viewAllPath,
}) => {
  const validateTimeSlots = event => event.timeSlots.nodes.length > 0
  let cards

  if (loading || !events) {
    cards = (
      <div className={style.spinner}>
        <Spinner type="circle" />
      </div>
    )
  } else {
    const eventCards = events.events.filter(validateTimeSlots).map(event => (
      <EventCard
        key={event.id}
        className={style.eventCard}
        coverImage={event.coverPhoto}
        address={event.geo.address}
        date={formattedDateTimeRange({
          startAt: event.timeSlots.nodes[0].startAt,
          endAt: event.timeSlots.nodes[0].endAt,
          totalCount: event.timeSlots.totalCount,
          intl,
        })}
        title={event.title}
        url={`${event.source.url}?ref=universe-discover`}
        hostUrl={`${event.host.url}?ref=universe-discover`}
        hostName={event.host.name}
        price={formattedPriceRange({
          minPrice: event.minPrice,
          maxPrice: event.maxPrice,
          currency: event.currency,
          intl,
        })}
        sectionId={sectionId}
        page={page}
        slug={event.slug}
        type={event.type}
        hiddenDate={event.hiddenDate}
        hiddenPrice={event.hiddenPrice}
      />
    ))

    cards = (
      <Carousel.Cards>
        <MediaQuery minWidth={BREAK_MD}>
          {eventCards}
        </MediaQuery>
        <MediaQuery maxWidth={BREAK_MD - 1}>
          {eventCards}
          {events.totalCount > MAX_EVENT_CARDS && <FindMoreEvents sectionId={sectionId} page={page} />}
        </MediaQuery>
      </Carousel.Cards>
    )
  }

  return (
    <Carousel>
      <Carousel.Header>
        <MediaQuery minWidth={BREAK_MD}>
          <div className={style.title}>{title}</div>
          <div className={style.viewAll}>
            <Link to={viewAllPath} href={viewAllPath}>
              {intl.formatMessage(locale.viewAll)}
              <ChevronIcon />
            </Link>
          </div>
        </MediaQuery>
        <MediaQuery maxWidth={BREAK_MD - 1}>
          <div className={style.title}>{title}</div>
        </MediaQuery>
      </Carousel.Header>
      {cards}
    </Carousel>
  )
}

export const EventsCarousel = injectIntl(EventsCarouselComponent)
